<template>
  <div class="public-navbar">
    <v-toolbar
      v-resize="onResize"
      dark
      fixed
      app
      clipped-left
      :color="dark ? 'active-menu' : 'black'"
      :class="
        user != null && showPanelInv != false
          ? { [`pt-${isMobile ? 0 : 0}`]: true }
          : { [`pt-${isMobile ? 0 : 0}`]: true }
      "
      :style="{ marginTop: devAlertOffset + 'px' }"
    >
      <router-link to="/">
        <img
          alt="RedCapital logo"
          :src="`${RedCapital[SelectedCountry].Logo}`"
          class="rclogo"
          style="padding-right: 20px"
        />
      </router-link>
      <img
        v-if="user != null && showPanelInv != false"
        alt="RedCapital logo"
        :src="urlimag"
        class="invlogo"
      />
      <v-toolbar-items v-if="!isMobile" style="width: 100%">
        <v-btn
          v-if="
            !valroutesfacto && projectsVisibility && SelectedCountry != 'PYME'
          "
          v-show="!userAnglo"
          class="font-OneRem"
          style="text-transform: capitalize; font-size: 1.2rem !important"
          to="/invertir"
          flat
          small
        >
          Invertir
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          style="height: auto; padding: 5px 25px; font-size: 1rem !important"
          class="dis-none rc-navEmpresa"
          to="/panel-facto/empresas"
          flat
          v-if="businesSelected != null && menu == 3"
        >
          {{ businesSelected.nombre }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="user != null && user.user_tipo_id == 1"
          to="/admin/asociar"
          flat
        >
          Controlar cuenta
        </v-btn>
        <v-btn
          class="ml-2"
          style="
            text-transform: capitalize;
            height: auto;
            padding: 5px 17px;
            font-size: 1rem !important;
          "
          v-if="user == null"
          outline
          round
          color="white"
          dark
          v-on="on"
          to="/registrar"
        >
          Registrarse
        </v-btn>
        <v-btn
          class="ml-2"
          style="
            text-transform: capitalize;
            height: auto;
            padding: 5px 17px;
            background: rgba(81, 89, 96, 80%) !important;
            font-size: 1rem !important;
          "
          v-if="user == null"
          outline
          round
          color="white"
          dark
          v-on="on"
          to="/login"
        >
          Ingresar
        </v-btn>

        <v-btn @click="buscoFactoring = true"
               class="ml-2 " 
               style="text-transform:capitalize;height: auto;padding: 5px 17px;font-size:1rem !important;background: #EC6B1C !important;"
               outline
               round
               color="white"
               dark
               v-on="on"
              >
          <img :src="buscoFactoringImg" style="width: 65px; height: auto; margin-right: 8px; margin-bottom: -5px;" />
          ¡Busco factoring!
          
        </v-btn>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="user != null" icon @click="openTutorialBar" style="position: relative;" v-on="on" v-bind="attrs" class="ma-2">
              <v-icon large>help_outline</v-icon>
              <div :class="classMenuTutorial === '1' ? '' : 'rc_notificacion'" style=" "></div>
          </v-btn>
          </template>
          <span>Tutoriales</span>
      </v-tooltip>
        <v-menu offset-y v-if="user != null">
          <template v-slot:activator="{ on }">
            <v-btn
              class="ml-2"
              style="
                text-transform: capitalize;
                height: auto;
                padding: 5px 17px;
                font-size: 1rem !important;
              "
              outline
              round
              color="white"
              dark
              v-if="user != null"
              v-on="on"
            >
              {{ nombreCompleto }}
              <v-icon>arrow_drop_down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile  v-if="user.control_account == 1" to="/panel-facto/controlar-cuentas">
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat>
                Controlar cuenta
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile
            
              to="/panel-facto/cuenta-banco"
            >
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat>
                Mis datos
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile
            
              to="/panel-facto/empresas"
            >
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat>
                Mis Empresas
              </v-list-tile-title>
            </v-list-tile>
            
            <v-list-tile @click="logout">
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat>
                Cerrar sesión
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <div class="ml-auto d-flex flex-row flex-wrap">
        <v-toolbar-side-icon
          v-if="isMobile"
          @click="openTutorialBar"
          alt="Mostrar menu tutorial"
        >
          <v-icon>help</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-side-icon
          v-if="isMobile"
          @click="showMenu = true"
          alt="Mostrar menu"
          aria-label="Menu"
        >
          <v-icon>account_circle</v-icon>
        </v-toolbar-side-icon>
      </div>
    </v-toolbar>
    <!-- Menu Movil -->
    <v-navigation-drawer
      v-model="showMenu"
      right
      app
      fixed
      temporary
      class="rc-menuDrawerSitios"
    >
      <!-- Datos usuario logeado en Panel inversionista y solicitante -->
      <v-list class="transparent" v-if="user != null">
        <!-- Avatar -->
        <v-list-tile class="v-list-item rc-listAvatar" style="height: 80px">
          <div style="text-align: center; width: 100%; line-height: 1">
            <v-icon large style="margin-bottom: 10px">account_circle</v-icon>
            <div>{{ nombreCompleto }}</div>
          </div>
        </v-list-tile>
        <!-- Avatar -->
        <!-- Menu solicitante -->
        <v-list
        
          class="transparent pa-2"
        >
          <div
            v-for="(perfilSolicitanteMenu, index2) in perfilSolicitanteMenus"
            :key="`${perfilSolicitanteMenu.icon}-${index2}`"
          >
            <v-list-tile
              v-if="!perfilSolicitanteMenu.categories"
              class="v-list-item rc-list-item rc-listItem-pad"
              :active-class="activeClassMenu"
              :to="
                perfilSolicitanteMenu.to.path
                  ? perfilSolicitanteMenu.to.path
                  : { name: perfilSolicitanteMenu.to.name }
              "
            >
              <div style="text-align: center; width: 100%; line-height: 1">
                <span
                  class="rc-listItem-img material-icons-outlined"
                  style="height: 26px; width: 26px"
                  >{{ perfilSolicitanteMenu.icon }}</span
                >
                <div class="rc-listItem-title">
                  {{ perfilSolicitanteMenu.text }}
                </div>
              </div>
            </v-list-tile>

          </div>
          <v-list-tile
            class="v-list-item rc-listItem-pad rc-listCerrarSesion"
            :active-class="activeClassMenu"
            @click="logout"
          >
            <div style="text-align: center; width: 100%; line-height: 1">
              <v-icon class="rc-listItem-img">logout</v-icon>
              <div class="rc-listItem-title">Cerrar sesión</div>
            </div>
          </v-list-tile>
        </v-list>
      </v-list>
      <!-- Datos usuario logeado en Panel inversionista y solicitante -->
   
    </v-navigation-drawer>

    <v-dialog
        v-model="buscoFactoring"
        :full-width="false"
        width="600"
        persistent
        class="b-radius">
        <v-card
        class="text-xs-center pb-2"
        style="position: relative"
        >
        <v-btn class="btnclose" @click="buscoFactoring = false"> x </v-btn>
        <v-container class="pb-0">
            <v-layout row wrap>
            <v-flex xs12 class="pa-3 text-xs-center">
                <h3 class="text-uppercase font-weight-bold pa-2">Complete el formulario y te contactaremos:</h3>
                <v-text-field
                label="Nombre de tu cliente"
                v-model="formBuscoFactoring.nombre"
                class="rc-dense-input mt-2 border-text"
                outline
                :rules="formBuscoFactoring.nombreRule"
                >
                </v-text-field>
                <v-text-field
                label="NIT de tu cliente"
                v-model="formBuscoFactoring.nit"
                class="rc-dense-input mt-2 border-text"
                outline
                :rules="formBuscoFactoring.nitRule"
                >
                </v-text-field>
                <v-select
                  v-model="formBuscoFactoring.businessSelected"
                  :rules="formBuscoFactoring.empresaRule"
                  class="rc-dense-input mt-2 border-text"
                  outline
                  :items="formBuscoFactoring.business"
                  item-text="nombre"
                  item-value="id"
                  label="Empresa"
                ></v-select>
                <v-text-field
                @blur="blurEvent(formBuscoFactoring, 'monto', formBuscoFactoring.monto)"
                label="Monto de facturación por factura"
                v-model="formBuscoFactoring.monto"
                class="rc-dense-input mt-2 border-text"
                outline
                :rules="formBuscoFactoring.montoRule"
                >
                </v-text-field>
                <v-text-field
                label="Plazo de facturación (días)"
                v-model="formBuscoFactoring.plazo"
                class="rc-dense-input mt-2 border-text"
                outline
                :rules="formBuscoFactoring.plazoRule"
                >
                </v-text-field>
                <v-select
                  v-model="formBuscoFactoring.periodicidad"
                  :items="formBuscoFactoring.periodicidades"
                  item-text="label"
                  item-value="value"
                  label="Periodicidad de facturación"
                  class="rc-dense-input mt-2 border-text"
                  outline
                  :rules="formBuscoFactoring.periodicidadRule"
                ></v-select>
            </v-flex>
            </v-layout>
        </v-container>
        <v-action class="pb-2">
            <v-btn class="rc-btn" @click="guardar_busco_factoring"> Enviar </v-btn>
        </v-action>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  perfilInversionistaMenus, // Menus para sitio inversionista
  perfilSolicitanteMenus, // Menus para sitio Solicitante
} from "@/models/DashboardLinks";
import { EventBus } from "@/main";
import { RedCapital, RedCapitalConfig, SelectedCountry } from "@/configuration";
import {formatCurrency} from "@/utils"
import API from '@/api';

@Component({
  props: {
    devAlertOffset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState(["user", "menu", "showPanelInv", "businesSelected"]),
    canShowLinks() {
      return (
        this.$route.path.startsWith("/panel/") ||
        this.$route.path.startsWith("/panel-facto/")
      );
    },
    projectsVisibility() {
      return (
        this.$store.state.user != null ||
        RedCapitalConfig(SelectedCountry).Project.PublicVisibility
      );
    },
    activeClass() {
      return "primary white--text";
    },
    accountType() {
      return this.$store.state.user.user_tipo_id == 2
        ? "investor"
        : "applicant";
    },
    urlimag() {
      return this.$store.state.menu == 2
        ? "/images/sitio-inversionista.png"
        : "/images/sitio-solicitante.png";
    },
    valroutesfacto() {
      return this.$route.path.startsWith("/panel-facto/");
    },
    userAnglo() {
      return this.$store.state.user != null &&
        this.$store.state.user.via_id == 2
        ? true
        : false;
    },
    activeClassMenu() {
      return "rc-menuPanelActive";
    },
    buscoFactoringImg() {
      return "/images/busco_factoring.png";
    },
  },
  data() {
    return {
      SelectedCountry,
      RedCapital,
      perfilInversionistaMenus,
      perfilSolicitanteMenus,
      nombreCompleto: null,
      dark: true,
      canShowUserMenu: false,
      showMenu: false,
      showMenuTutorial: false,
      classMenuTutorial: '',
      isMobile: true,
      uglyLinks: [
        {
          to: "/quienes-somos",
          text: "Sobre nosotros",
        },
        {
          to: "/prensa",
          text: "En prensa",
        },
        {
          to: "/contacto",
          text: "Contacto",
        },
        {
          to: "/preguntas-frecuentes",
          text: "Preguntas frecuentes",
        },
        {
          to: "/garantia-riesgos",
          text: "Garantías y riesgos",
        },
      ],
      buscoFactoring: false,
      formBuscoFactoring:{
        nombre: null,
        nit: null,
        business: null,
        businessSelected: 0,
        monto: null,
        plazo: null,
        periodicidad:null,
        periodicidades: [
          { value: 1, label: 'Cada 1 semana' },
          { value: 2, label: 'Cada 2 semanas' },
          { value: 3, label: 'Cada 3 semanas' },
          { value: 4, label: 'Cada 1 mes' },
          { value: 5, label: 'Cada 2 meses' },
          { value: 6, label: 'Cada 3 meses' },
          { value: 7, label: 'Cada 4 meses' },
          { value: 8, label: 'Cada 5 meses' },
          { value: 9, label: 'Cada 6 meses' },
        ],
        nombreRule: [
          (v) => !!v || "Ingrese nombre",
          (v) => /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s]+$/.test(v) || "Ingrese solo letras, sin números ni caracteres especiales",
          (v) => v.length <= 255 || "Nombre no puede exceder los 255 caracteres."
        ],
        nitRule: [
          (v) => !!v || "Ingrese NIT",
        ],
        montoRule: [
            (v) => !!v || "Ingrese monto de facturación",
            (v) => !/[^\d.,]/gim.test(v) || "Tiene que ser solo números, coma o punto",
            (v) => /^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?$|\d+)$/.test(v) || "Formato incorrecto",
            (v) => v.length > 3 || "Valor ingresado es muy bajo.",
            (v) => v.length < 20 || "Valor ingresado es demasiado alto."
        ],
        plazoRule: [
          (v) => !!v || 'Ingrese plazo de facturación',
          (v) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros",
          (v) => v.length <= 3 || "Valor ingresado es demasiado alto"
        ],
        empresaRule: [
          (v) => v>=0 || 'Ingrese empresa'
        ]
      },
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth <= 960) {
        this.$data.isMobile = true;
      } else {
        this.$data.isMobile = false;
        this.$data.showMenu = false;
      }
    },
    login() {
      this.$data.showMenu = false;
      this.$data.canShowUserMenu = false;
      this.$data.showMenuTutorial = false;
      EventBus.$emit("open-login-dialog");
    },
    logout() {
      EventBus.$emit("logout");
    },
    openTutorialBar(){
      if(this.$data.classMenuTutorial != '1'){
        API.changeTutorialVideo(this.$store.state.user.id).then((response) => {
          this.$data.classMenuTutorial = response.data.data;
        });
      }
      this.$data.showMenuTutorial = !this.$data.showMenuTutorial;
      this.$store.commit('showMenuTutorial', this.$data.showMenuTutorial);
    },
    goblog() {
      window.open("https://blog.redcapital.cl/", "_blank");
    },
    capitalize(texto) {
      // #Pendiente dejar esta funcion global para llamar donde sea.
      const lower = texto.toLowerCase();
      return texto.charAt(0).toUpperCase() + lower.slice(1);
    },
    guardar_busco_factoring(){
      API.buscoFactoring(this.$store.state.user.id, this.$data.formBuscoFactoring)
      .then((res) => {
          if(res.errors){
            if(res.errors.alias){
              EventBus.$emit("alertsError", true,'¡Atención!',res.errors.alias[0])
            }
            if(res.errors.numero){
              EventBus.$emit("alertsError", true,'¡Atención!',res.errors.numero[0])
            }
          }else{
            EventBus.$emit("snack-success", "Gracias, será contactado a la brevedad por nuestros ejecutivos");
            this.$data.formBuscoFactoring.nombre = null;
            this.$data.formBuscoFactoring.nit = null;
            this.$data.formBuscoFactoring.monto = null;
            this.$data.formBuscoFactoring.plazo = null;
            this.$data.formBuscoFactoring.periodicidad = null;
            this.$data.formBuscoFactoring.businessSelected = null;
            this.$data.buscoFactoring = false;
          }
        })
      .catch((err)=>{
          EventBus.$emit("snack-error", "Error al ingresar la solicitud");
      })
    },

    blurEvent(form, campo, value) {
        const formattedValue = formatCurrency(value, 'blur');
        form[campo] = formattedValue; 
    }
  },
  beforeMount() {
    if(this.$store.state.user.tutorial === 1){
      this.$data.classMenuTutorial = '1';
    }
    this.$data.nombreCompleto =
      this.capitalize(this.$store.state.user.nombre) +
      " " +
      this.capitalize(this.$store.state.user.app_pat);

      API.getEmpresas(this.$store.state.user.id)
        .then((data) => {
          this.$data.formBuscoFactoring.business = [
            { nombre: 'No seleccionar empresa', id: null },
            ...data,
          ];
          this.$data.formBuscoFactoring.businessSelected = null;
        })
  },
  watch:{
		"$store.state.showMenuTutorial":{
        handler(){
          this.$data.showMenuTutorial = this.$store.state.showMenuTutorial;
        },
        immediate: true,
		  },
      "$store.state.user":{
        handler(){
          this.$data.nombreCompleto = this.capitalize(this.$store.state.user.nombre) + " " +
          this.capitalize(this.$store.state.user.app_pat);
        },
        immediate: true,
		  },		
		},
})
export default class NavBar extends Vue {}
</script>

<style lang="scss" scoped>
.rc-navEmpresa {
  border: 1.5px solid #ffffff;
  border-radius: 500px;
  color: #ffffff;
  font-family: SF Pro Text;
  font-style: normal;
  font-weight: 600;
  background-color: transparent;

  /* identical to box height */
}
.font-OneRem {
  font-size: 1rem !important;
}
.navbar {
  z-index: 3;
}
.rclogo {
  @media (max-width: 960px) {
    height: 40px;
  }
  @media (min-width: 960px) {
    height: 50px;
  }
}
.invlogo {
  @media (max-width: 960px) {
    height: 20px;
  }
  @media (min-width: 960px) {
    height: 25px;
  }
}
.dis-none {
  @media (max-width: 600px) {
    display: none;
  }
}
.v-menu__content {
  position: fixed !important;
  border-radius: 1rem !important;
}
.active {
  box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.btnsitio {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}

// MENUS Sito Solicitante e Inversionista
/*.rc-listCerrarSesion{
		position: absolute;
		bottom: 0;
		width: 284px;
		margin-bottom: 30px;
		a{
			div{
				i{
					color: $rc-prim-n1 !important;
				}
				div
				{
					color: $rc-prim-n1 !important;
					font-weight: 600;
				}
			}
		}
	}*/
.rc-menuDrawerSitios {
  margin-top: 64px !important;
  z-index: 1;
  width: 150px !important;
  height: calc(100vh - 64px) !important;
  min-height: 100%;
}
.rc-listItem-title {
  font-weight: 600;
  //color: $rc-prim-g2 !important;
}
.rc_notificacion {
		height: 14px; 
		width: 14px;
		position: absolute; 
		right: 0px; 
		top: 5px; 
		background-color: red; 
		border-radius: 50%;
	}
// Breakpoints
@each $breakpoint in $breakpoints_screen_text {
  @include breakpoint_media_queries($breakpoint) {
    @if $breakpoint == "x-large" {
    } @else if $breakpoint == "large" {
    } @else if $breakpoint == "medium-to-large" {
      .rc-menuDrawerSitios {
        margin-top: 0 !important;
        z-index: 5;
        width: 300px !important;
      }
      .rc-listItem-img {
        float: left;
      }
      .rc-listItem-title {
        float: left;
        line-height: 2;
        margin-left: 10px;
      }
    } @else if $breakpoint == "small-to-medium" {
      .rc-menuDrawerSitios {
        margin-top: 0 !important;
        z-index: 5;
        width: 300px !important;
      }
      .rc-listItem-img {
        float: left;
      }
      .rc-listItem-title {
        float: left;
        line-height: 2;
        margin-left: 10px;
      }
    } @else if $breakpoint == "small" {
      .rc-menuDrawerSitios {
        margin-top: 0 !important;
        z-index: 5;
        width: 300px !important;
      }
      .rc-listItem-img {
        float: left;
      }
      .rc-listItem-title {
        float: left;
        line-height: 2;
        margin-left: 10px;
      }
    }
  }
}
</style>
